export default "__VITE_ASSET__mAWISLlI__"